import React from 'react';
import { makeStyles, GRAY, Typography } from '@applyboard/ui-components';
var useStyles = makeStyles({
  info: {
    marginTop: '8px',
    color: "".concat(GRAY[10])
  }
});
var GradeConverionInfo = function GradeConverionInfo() {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Typography, {
    variant: "indicator",
    className: classes.info
  }, "This grade will be converted to the school\u2019s grading system.");
};
export default GradeConverionInfo;